import ApiService from "./ApiService";

export default class ReportService extends ApiService
{
    collection = 'reports'
}